import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges multiple class names into a single optimized string.
 * It uses `clsx` to handle conditional class merging and `twMerge`
 * to resolve Tailwind CSS conflicts.
 *
 * @param {...ClassValue} inputs - A list of class names, which can be strings, arrays, or objects with conditional keys.
 * @returns {string} A single string containing the merged and optimized class names.
 *
 * @example
 * // Basic usage
 * cn("p-4", "text-white", isActive && "bg-blue-500", "bg-red-500");
 * // Output: "p-4 text-white bg-blue-500"
 *
 * @example
 * // Using objects for conditional class names
 * cn("text-lg", { "font-bold": isBold, "italic": isItalic }, "text-secondary");
 * // Output (if `isBold = true` and `isItalic = false`): "text-lg font-bold text-secondary"
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
